import styles from './Buttton.module.scss'

type ButtonProps = {
    children: React.ReactNode
} & React.ButtonHTMLAttributes<HTMLButtonElement>

export const Buttton = ({ children, ...rest }: ButtonProps) => {
    return <button type='button' {...rest} className={`${styles.button} ${rest.className}`}>
        {children}
    </button>
}